<template>
    <div class="project-overview" v-if="project">
        <v-container v-if="project.configuration" fluid>
            <ProjectOverviewHeader
                    class="header"
                    :img="require('@/assets/img/logo-project-majorelle.png')"
                    :name="project.name"
                    :background-color="project.color">
                <template slot="filters">
                    <v-tabs v-model="tab"
                            show-arrows
                            background-color="transparent"
                            color="white">
                        <v-tab class="overview-tab">
                            <div class="tab__text">
                                <div class="tab__title">Macroscope</div>
                            </div>
                            <div class="tab__actions"></div>
                        </v-tab>
                        <v-tab :key="item.id" v-for="item of project.configuration.analyses"
                            @change="setCurrentAnalysisLabel(item)">
                            <div class="tab__text">
                                <div class="tab__subtitle">{{item.type}}</div>
                                <div class="tab__title">{{item.label}}</div>
                            </div>
                            <div class="tab__actions">
                                <TabOverviewTabMenu
                                  :analysisId='item.id'
                                  @deleteAnalysisClick="deleteAnalysis(item.id)"
                                ></TabOverviewTabMenu>
                            </div>
                        </v-tab>
                        <div class="new-tab-btn" v-ripple @click="launchNewAnalysisWizard()">
                            <v-icon color="white">mdi-plus</v-icon>
                            Add an analysis
                          <NewAnalysis
                            v-bind:dialog_visible="addAnalysisDialog"
                            v-bind:analysis_template="analysis_template"
                            v-on:cancel="addAnalysisDialog = false"
                            v-on:create="createNewAnalysis($event)"
                            >
                          </NewAnalysis>
                        </div>
                    </v-tabs>
                    <div class="project-filters">
                        <ProjectOverviewFilters
                                v-model="project"
                                :project="project"
                                :selectedCommunities="project.configuration.communities"
                                :isDialogOpened="isDialogOpened"
                                :analysisLabel="currentAnalysisLabel"
                                :tab="tab"
                        ></ProjectOverviewFilters>
                    </div>
                </template>
            </ProjectOverviewHeader>
            <v-tabs-items v-if="project" class="project-tabs-items" v-model="tab">
                <v-tab-item>
                    <Overview
                            :project="project"
                    ></Overview>
                </v-tab-item>
                <v-tab-item :key="item.id" v-for="item of project.configuration.analyses">
                    <Influence v-if="item.type == 'Influence'"
                      :community="item.query"
                      :project="project"
                    />
                    <MicroInfluence v-if="item.type == 'Micro-Influence'"
                      :community="item.query"
                      :project="project"
                    />
                    <Expression v-if="item.type == 'Expression'"
                      :community="item.query"
                      :project="project"
                      :field-of-expression="item.field_of_expression"
                    />
                    <Exposition v-if="item.type == 'Exposition'"
                      :community="item.query"
                      :project="project"
                      :exposed-to="item.field_of_expression_query"
                    />
                </v-tab-item>
            </v-tabs-items>
            <Loader v-if="!project">
            </Loader>
        </v-container>
    </div>
</template>

<script>
    import ProjectOverviewHeader from "../components/Projects/Project/ProjectHeader";
    import TabOverviewTabMenu from "../components/Projects/Project/TabMenu";
    import ProjectOverviewFilters
        from "../components/Projects/Project/ProjectFilters/ProjectOverviewFilters";
    import NewAnalysis from "../components/Projects/Project/NewAnalysis";
    import Influence from "../components/Projects/Project/Influence";
    import MicroInfluence from "../components/Projects/Project/MicroInfluence";
    import Expression from "../components/Projects/Project/Expression";
    import Exposition from "../components/Projects/Project/Exposition";
    import Overview from "../components/Projects/Project/Overview";
    import {menuShrink, clearListener} from '../_utils/menuShrink'
    import {store} from "../store/store";
    import Loader from "../components/Loader";
    import axios from "axios";

    export default {
        name: "Project",
        props: [],
        components: {
            Overview,
            ProjectOverviewFilters,
            TabOverviewTabMenu,
            ProjectOverviewHeader,
            NewAnalysis,
            Influence,
            MicroInfluence,
            Expression,
            Exposition,
            Loader
        },
        data: () => ({
            addAnalysisDialog: null,
            dialog: null,
            //analyses: [],
            currentAnalysisLabel: "",
            tab: 0,
            analysis_template: null, // used for analysis creation
        }),
        computed: {
            // eslint-disable-next-line vue/return-in-computed-property
            isDialogOpened: function () {
                if (this.$route.params.dialog !== undefined) {
                    return this.$route.params.dialog || this.dialog
                } else if (this.dialog) {
                    return this.dialog
                }
            },
            project: {
                get: function () {
                    return store.state.project
                },
                set: function () {
                    return store.state.project
                }
            },
        },
        methods: {
            launchNewAnalysisWizard() {
                // If for some strange reason, previous was not correctly closed
                if (this.addAnalysisDialog) {
                  this.addAnalysisDialog = false
                }
                // Consider async/await as more readable
                // We get the form-template from API
                store.dispatch("getAccessToken").then(token => {
                    var url =  "projects/" + this.project.id + "/analyses";
                    var payload = { type: "Influence"} // This does not mather at this moment
                    axios.post(url, JSON.stringify(payload), {
                        headers: {
                            "Authorization": "Bearer " + token,
                            "Content-type": "application/json"
                        }
                    }).then(resp => {
                      this.analysis_template = resp.data
                      this.addAnalysisDialog = true;
                    }).catch(err => err);
                });

            },
            createNewAnalysis(analysis_partial) {
              store.dispatch("getAccessToken").then(token => {
                  var url =  "projects/" + this.project.id + "/analyses";
                  var payload = analysis_partial
                  axios.post(url, JSON.stringify(payload), {
                      headers: {
                          "Authorization": "Bearer " + token,
                          "Content-type": "application/json"
                      }
                  }).then(resp => {
                    this.project.configuration.analyses.push(resp.data);
                    this.addAnalysisDialog = false;
                  }).catch(err => err);
              });
            },
            setProjectAnalysisQuery(analysis) {
              console.log("Requesting details of analysis: " + id)
              store.dispatch("getAccessToken").then(token => {
                  var url =  "projects/" + this.project.id + "/analyses/" + id;
                  axios.get(url, {
                      headers: {
                          "Authorization": "Bearer " + token,
                          "Content-type": "application/json"
                      }
                  }).then(resp => {
                    console.log("Received analysis details:",  resp.data);

                    console.log("Found analysis: to update", analysis);
                    analysis.query = resp.data.query;
                  }).catch(err => err);
              });

            },
            deleteCommunityFromProject() {
                const communityId = this.$route.params.id;
                const projectId = this.$route.params.projectId;
                store.dispatch('deleteCommunityFromProject', {
                    projectId: projectId,
                    communityId: communityId
                })
            },
            deleteAnalysis(id) {
              console.log("deleteAnalysis method", id);
              store.dispatch("getAccessToken").then(token => {
                  var url =  "projects/" + this.project.id + "/analyses/" + id;
                  axios.delete(url, {
                      headers: {
                          "Authorization": "Bearer " + token,
                          "Content-type": "application/json"
                      }
                  }).then(resp => {
                    console.log("Analysis deleted: " + resp.data)
                    console.log("Analyses before:", this.project.configuration.analyses)
                    this.project.configuration.analyses =
                      this.project.configuration.analyses.filter(a => {
                        var aid = a.id
                        console.log("analysis id=", aid, id)
                        return aid != id
                      })
                    console.log("Analyses after:", this.project.configuration.analyses)
                  }).catch(err => err);
              });
            },
            setCurrentAnalysisLabel(item) {
              this.currentAnalysisLabel = item.label;
              if (item.type == "Expression" && item.field_of_expression) {
                  this.currentAnalysisLabel += " expression: " + item.field_of_expression;
              }
            },
        },
        mounted() {
            //Setting project data
            const projectId = this.$route.params.projectId;
            store.dispatch('setProject', projectId)

            // Redirecting while page loaded with incorrect path
            const regExp = /^(\/projects\/project\/[0-9]+\/)$/;
            if (!regExp.exec(this.$route.path)) {
                this.$router.push({name: "ProjectOverview", dialog: false})
            }

            //Shrinking menu on scroll
            menuShrink('.header');

            // Checking if communities are already in store. Required for loading directly projects page
            store.dispatch('getCommunities').then(resp => {
                if (!resp.length) {
                    store.dispatch('setCommunities')
                }
            });
        },
        destroyed() {
            clearListener();
            store.dispatch('setProject', null)
        },
        watch: {
            length(val) {
                this.tab = val - 1
            },
            $route: {
                handler: function (val, oldVal) {
                    if (oldVal.name === "DeleteProjectCommunityConfirmation" && this.$route.params.id !== undefined) {
                        this.deleteCommunityFromProject()
                    }
                },
                deep: true
            }
        },
    }
</script>

<style scoped>

</style>
